import { render } from "./RadioButton.vue?vue&type=template&id=7c6fa60b"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"

import "./RadioButton.vue?vue&type=style&index=0&id=7c6fa60b&lang=scss"
script.render = render

export default script